import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PAGE_LAYOUT_HANDLER } from '@spartacus/storefront';
import { GenCartDetailsModule } from './cart-details/cart-details.module';
import { GenCartCouponModule } from './cart-coupon/cart-coupon.module';
import { GenCartSharedModule } from './cart-shared/cart-shared.module';
import { GenAddedToCartDialogModule } from './added-to-cart-dialog/added-to-cart-dialog.module';
import { GenCartProceedToCheckoutModule } from './cart-proceed-to-checkout/cart-proceed-to-checkout.module';
import { CartPageLayoutHandler, ActiveCartOrderEntriesContext } from '@spartacus/cart/base/components';
import { ActiveCartOrderEntriesContextToken } from '@spartacus/cart/base/root';

@NgModule({
  imports: [
    CommonModule,
    GenCartSharedModule,
    GenCartDetailsModule,
    GenCartProceedToCheckoutModule,
    GenCartCouponModule,
    GenAddedToCartDialogModule,
  ],
  exports: [
    GenCartSharedModule,
    GenCartProceedToCheckoutModule,
    GenCartCouponModule,
    GenAddedToCartDialogModule,
    GenCartDetailsModule,
  ],
  providers: [
    {
      provide: PAGE_LAYOUT_HANDLER,
      useExisting: CartPageLayoutHandler,
      multi: true,
    },
    {
      provide: ActiveCartOrderEntriesContextToken,
      useExisting: ActiveCartOrderEntriesContext,
    },
  ],
})
export class GenCartComponentsModule {}
